export default __webpack_public_path__ + "static/media/hbar.7d6a1c37.svg";